module.exports = __webpack_public_path__ + "static/media/15.1272d0c8.mp3";